import { Suspense, useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from '@store/index'
import { router } from './routes'
import Loader from '@components/common/Loader/Loader'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { fetchProfile } from '@store/auth/authSlice'

// Bootstrap styles and icons
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '@styles/crif-theme.scss'

const AppContent = () => {
  const dispatch = useAppDispatch()
  const { isAuthenticated } = useAppSelector(state => state.auth)

  useEffect(() => {
    // Fetch user profile on app load if authenticated
    if (isAuthenticated) {
      dispatch(fetchProfile())
    }
  }, [dispatch, isAuthenticated])

  return (
    <Suspense fallback={<Loader fullScreen text="Loading..." />}>
      <RouterProvider router={router} />
    </Suspense>
  )
}

function App() {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  )
}

export default App
